import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import React from "react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";

const DiversionVillaCarlosPazSec = ({ hasBg = true }) => {
  return (
    <>
      <section
        id="diversion"
        className={`screenshots-section ptb-100 ${
          hasBg ? "gray-light-bg" : ""
        }`}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="section-heading text-center">
                {hasBg ? (
                  <span className="text-uppercase color-secondary sub-title">
                    Sierras Fiesta y mas
                  </span>
                ) : (
                  ""
                )}
                <h2>Lo mejor de Villa Carlos Paz</h2>
                <p className="lead">
                Montañas, sierras, ríos y los paisajes más hermosos de Córdoba te esperan. Hemos preparado un viaje de egresaditos distintivo para crear recuerdos inolvidables.
                </p>
              </div>
            </div>
          </div>
          <Swiper
            // install Swiper modules
            modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
            centeredSlides={true}
            spaceBetween={50}
            slidesPerView={1}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            // autoplay= {{delay: 2000}}
            loop={true}
            // navigation
            pagination={{ clickable: true }}
            // scrollbar={{ draggable: true }}
            onSwiper={(swiper) => console.log(swiper)}
            // onSlideChange={() => console.log('slide change')}
          >
            <SwiperSlide>
              <img
                src="assets/img/villaCarlosPazSec/diversion/imagenescordoba1.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/villaCarlosPazSec/diversion/imagenescordoba2.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/villaCarlosPazSec/diversion/imagenescordoba3.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/villaCarlosPazSec/diversion/imagenescordoba4.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/villaCarlosPazSec/diversion/imagenescordoba5.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/villaCarlosPazSec/diversion/imagenescordoba6.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/villaCarlosPazSec/diversion/imagenescordoba7.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src="assets/img/villaCarlosPazSec/diversion/imagenescordoba8.jpg"
                alt="img"
                className="img-fluid"
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </section>
    </>
  );
};

export default DiversionVillaCarlosPazSec;
